import * as angular from 'angular';
import * as _ from 'lodash';

import { IGroupService, IUserService } from '../../services/data';
import { ComponentDefinition, KeyValuePair } from '../../models';
import { guidEmpty, noneGroup } from '../../common/constants';
import { logbookModalRefresh } from '../../common/events';

class GroupsSelectController implements angular.IComponentController {
    groups: KeyValuePair<string, string>[];
    onChange: ({ item: any }) => void;
    selectedGroupName: string;
    selectedGuid: string;
    
    readonly allowedGroups: string[];

    static $inject = [
        '$scope',
        'groupService',
        'userService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _groupService: IGroupService,
        private _userService: IUserService
    ) { }

    $onInit() {
        this.initializeGroup();
        // TODO: Refactor to avoid 2-way binding on selectedGuid
        this._$scope.$on(logbookModalRefresh, (ev, params) => {
            if (params && params.group) {
                this.selectedGuid = params.group.guid;
                this.initializeGroup();
            }
        });
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['selectedGuid']?.currentValue || changesObj['allowedGroups'].currentValue) {
            this.initializeGroup();
        }
    }

    initializeGroup() {
        this._groupService
            .getAllAsTreeOrdered()
            .then(data => {
                this.selectedGroupName = '';
                if (this.allowedGroups && this.allowedGroups.length > 0) {
                    data = data.filter(group => this.allowedGroups.indexOf(group.guid) >= 0);
                }
                const tmp = data
                    .map(group => {
                    if (this.selectedGuid === group.guid) {
                        this.selectedGroupName = group.uniqueName;
                    }
                    return {
                        key: group.guid,
                        value: group.uniqueName
                    };
                });
                this.groups = [noneGroup].concat(tmp);
                if (!this.selectedGuid) {
                    this.selectedGuid = guidEmpty;
                }
            })
            .catch(reason => {
                this.selectedGuid = guidEmpty;
            });
    }

    onGroupChange(value: string) {
        if (value) {
            if (this.onChange) {
                this.onChange({ item: value });
            }
        }
        this.selectedGroupName = _.find(this.groups, g => g.key === value)?.value;
    }

    save(groupGuid: string): void {
        this._userService.saveLastSelectedGroup(groupGuid);
    }
}

export const wtGroupsSelect: ComponentDefinition = {
    componentId: 'wtGroupsSelect',
    controller: GroupsSelectController,
    controllerAs: 'vm',
    template: require('./groupsSelect.component.html'),
    bindings: {
        allowedGroups: '<?',
        selectedGroupName: '=',
        selectedGuid: '=?',
        onChange: '&?'
    }
};